// src/pages/Document/DocumentsForm.js

import React, { useState } from 'react';
import axios from '../../utils/axiosConfig';
import './DocumentsForm.css';
import { FiFileText, FiUpload } from 'react-icons/fi'; // Importing icons
import { useNavigate } from 'react-router-dom';

const DocumentsForm = () => {
  const [formData, setFormData] = useState({ name: '', pdf: null, logo: null });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // Loading state added

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePdfChange = (e) => {
    const file = e.target.files[0];
    if (file?.type === 'application/pdf') {
      setFormData({ ...formData, pdf: file });
      setError('');
    } else {
      setFormData({ ...formData, pdf: null });
      setError('Lütfen geçerli bir PDF dosyası yükleyin.');
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file?.type.startsWith('image/')) {
      setFormData({ ...formData, logo: file });
      setError('');
    } else {
      setFormData({ ...formData, logo: null });
      setError('Lütfen geçerli bir resim dosyası yükleyin.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, pdf, logo } = formData;

    if (!name || !pdf || !logo) {
      setError('Katalog adı, logo ve PDF dosyası gereklidir.');
      return;
    }

    const maxPdfSize = 10 * 1024 * 1024; // 10MB
    const maxLogoSize = 5 * 1024 * 1024; // 5MB

    if (pdf.size > maxPdfSize) {
      setError('PDF dosyası 10MB\'dan büyük olamaz.');
      return;
    }

    if (logo.size > maxLogoSize) {
      setError('Logo dosyası 5MB\'dan büyük olamaz.');
      return;
    }

    const uploadData = new FormData();
    uploadData.append('name', name);
    uploadData.append('pdf', pdf);
    uploadData.append('logo', logo);

    try {
      setLoading(true); // Start loading
      const token = localStorage.getItem('authToken');

      await axios.post('/api/documents', uploadData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      setMessage('Belge başarıyla eklendi.');
      setError('');
      setFormData({ name: '', pdf: null, logo: null });
      document.getElementById('pdfInput').value = '';
      document.getElementById('logoInput').value = '';
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Belge eklenirken bir hata oluştu.';
      setError(errorMsg);
      console.error('Error adding document:', err.response?.data || err.message);
      setMessage('');
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="documents-form-container">
      <h1>Belge Ekle</h1>
      {message && <p className="message success">{message}</p>}
      {error && <p className="message error">{error}</p>}
      {loading && <p className="message loading">Yükleniyor...</p>}
      <form className="documents-form" onSubmit={handleSubmit} encType="multipart/form-data">
        {/* Document Name */}
        <div className="form-field">
          <label htmlFor="name">Belge Adı</label>
          <div className="input-wrapper">
            <FiFileText className="input-icon" />
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Belge Adını Girin"
              required
            />
          </div>
        </div>

        {/* PDF Upload */}
        <div className="form-field">
          <label htmlFor="pdfInput">Belge PDF Dosyası</label>
          <div className="file-input-wrapper">
            <FiUpload className="file-input-icon" />
            <input
              type="file"
              id="pdfInput"
              name="pdf"
              accept="application/pdf"
              onChange={handlePdfChange}
              required
            />
            <span className="file-input-text">
              {formData.pdf ? formData.pdf.name : 'PDF Dosyası Seçin...'}
            </span>
          </div>
        </div>

        {/* Logo Upload */}
        <div className="form-field">
          <label htmlFor="logoInput">Belge Logosu</label>
          <div className="file-input-wrapper">
            <FiUpload className="file-input-icon" />
            <input
              type="file"
              id="logoInput"
              name="logo"
              accept="image/*"
              onChange={handleLogoChange}
              required
            />
            <span className="file-input-text">
              {formData.logo ? formData.logo.name : 'Logo Seçin...'}
            </span>
          </div>
        </div>

        {/* Submit Button */}
        <button type="submit" className="btn-submit" disabled={loading}>
          {loading ? 'Yükleniyor...' : 'Belge Ekle'}
        </button>
      </form>
    </div>
  );
};

export default DocumentsForm;
